import { Text } from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  NotificationEventType,
  notificationEventTypeToName,
} from "../../helper/notificationEventType";

type NotificationTitleProps = {
  eventType: NotificationEventType;
};

export const NotificationTitle: React.FC<NotificationTitleProps> = ({
  eventType,
}) => {
  const { t } = useTranslation();

  const eventTypeName = notificationEventTypeToName(eventType);
  const title = t(`notifications.eventTypes.titles.${eventTypeName}`);

  return (
    <Text strong ellipsis={{ tooltip: title }}>
      {title}
    </Text>
  );
};
